/* History timeline: sticky era-nav offset + scroll-spy, and reveal-on-scroll. Loaded by sections/timeline.liquid. */
(function () {
  'use strict';

  var doc = document;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  function initTimeline(root) {
    $$('[data-timeline]', root).forEach(function (section) {
      if (section.dataset.timelineReady) return;
      section.dataset.timelineReady = '1';

      // Keep the era nav (and anchor jumps) clear of the sticky site header.
      var header = doc.querySelector('.site-header--sticky');
      function setOffset() { section.style.setProperty('--tl-offset', (header ? header.offsetHeight : 0) + 'px'); }
      setOffset();
      window.addEventListener('resize', setOffset);

      var rows = $$('.timeline__row', section);
      var links = $$('.timeline__nav a[href^="#"]', section);
      var hasIO = 'IntersectionObserver' in window;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (hasIO && !reduced) {
        section.classList.add('timeline--js');
        var reveal = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-visible'); reveal.unobserve(en.target); }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
        rows.forEach(function (r) { reveal.observe(r); });
      }

      if (!links.length || !hasIO) return;
      var targets = links.map(function (a) { return doc.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
      function activate(id) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); }); }
      links.forEach(function (a) { a.addEventListener('click', function () { activate(a.getAttribute('href').slice(1)); }); });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) activate(en.target.id); });
      }, { rootMargin: '-25% 0px -55% 0px' });
      targets.forEach(function (t) { spy.observe(t); });
    });
  }

  window.theme.register(function (root) {
    initTimeline(root);
  });
})();
